import { HttpStatusCode } from "./http-status-code";
import { ValidationError } from "./validation-error";


export class HttpError {

  constructor(public statusCode: HttpStatusCode, public message: string, public validationErrors?: ValidationError[]) {
    this.validationErrors = validationErrors || [];
  }

  containsCode(code: string): Boolean {
    return this.validationErrors != null && this.validationErrors.find(e => e.code === code) != null;
  }

  getMessage(): string {
    if (this.validationErrors && this.validationErrors.length > 0) {
      return this.validationErrors[0].message;
    }
    return this.message;
  }
}
